/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Hatchery } from '../../models/hatchery';
import { HatcheryDto } from '../../models/hatchery-dto';

export interface UpdateHatchery$Params {
  hatcheryId: number;
      body: HatcheryDto
}

export function updateHatchery(http: HttpClient, rootUrl: string, params: UpdateHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
  const rb = new RequestBuilder(rootUrl, updateHatchery.PATH, 'put');
  if (params) {
    rb.path('hatcheryId', params.hatcheryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Hatchery>;
    })
  );
}

updateHatchery.PATH = '/api/hatchery/{hatcheryId}';
